import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { selectProductLifeReady } from 'quick-quote/product-life-ready/actions'
import { getSelectedProductCICombo } from '../selectors'
import VALUES from 'core/data-model/constants/values'

export const CIComboProductSelection = ({ getSelectedProductCICombo, selectProductLifeReady }) => {
  const productCICombo = [
    {
      text: '18 ปี',
      value: VALUES.CI_COMBO_CODE.W99FU18,
    },
    {
      text: 'ถึงอายุ 99 ปี',
      value: VALUES.CI_COMBO_CODE.W99FU99,
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">ระยะเวลาการชำระเบี้ยประกัน</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectProductLifeReady}
        value={getSelectedProductCICombo}
        options={productCICombo}
      />
    </div>
  )
}

const mapStateToProps = (state) => ({
  getSelectedProductCICombo: getSelectedProductCICombo(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectProductLifeReady: bindActionCreators(selectProductLifeReady, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(CIComboProductSelection)
